import { Injectable } from '@angular/core';
import { OidcSecurityService } from '../auth/services/oidc.security.service';

@Injectable()
export class AuthorizedStatusService {

    private authoizationStatus = false;

    constructor(private _securityService: OidcSecurityService) {
        this._securityService.getIsAuthorized().subscribe((status: boolean) => {
            this.authoizationStatus = status;
        })
    }

    public isAuthorized(): boolean {
        return this.authoizationStatus;
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/services/authorized-status.service.ts